import { mappingSort } from "routes/schedule/tree/schedules/mappingSort"

export function isSpecial(label) {
    return mappingSort({ label }).includes("@")
}
